import { Tabs } from "@ark-ui/react";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Tabs.Content>;

const Content = ({ ...props }: Props) => <Tabs.Content {...props} />;

export default Content;
